const single_sign_on = {
    forbidden_domains: 'I domini di posta elettronica pubblica non sono consentiti.',
    duplicated_domains: 'Ci sono domini duplicati.',
    invalid_domain_format: 'Formato del dominio non valido.',
    duplicate_connector_name: 'Il nome del connettore esiste già. Si prega di scegliere un nome diverso.',
};
export default Object.freeze(single_sign_on);
